import React from 'react'
import IndustrySector from '../industryComponents/IndustrySector'
import IndustryDesign from '../industryComponents/IndustryDesign'
import HomeTab from '../../home/HomeTab'
import HomeResource from '../../home/HomeResource'
import SustainabilityBanner from '../../sustainability/SustainabilityBanner'
import DynamicBreadcrumb from '../../../components/DynamicBreadcrumb'
import IndustryInvest from '../industryComponents/IndustryInvest'
import IndustryServe from '../industryComponents/IndustryServe'

const breadcrumbData = [
  {
    slug: "/",
    page: "Home",
  },
  {
    slug: "",
    page: "Industries",
  },
  {
    slug: "",
    page: "Educational Services",
  },
];

const bannerData = {
  img:"assets/images/educational-industry-banner.webp",
  leftHead:"Educational Services",
  rightHead:"Streamlining Academic Operations with Structured Information Management",
  desc:"Educational institutions depend on accurate, secure, easily accessible records to function efficiently. Dox and Box enables schools, colleges, and universities to manage paperless academic and administrative documents with precision, ensuring secure storage, organized systems, instant retrieval to support seamless institutional operations."
}

const sectorData ={
  head:"Sector Overview",
  overview:"The education sector handles vast volumes of data, including student records, admissions documents, examination papers, certificates, administrative files. Ensuring data accuracy, security, compliance is essential for smooth functioning and regulatory adherence. Dox and Box provides secure, scalable, organized document management solutions that help educational institutions improve efficiency, enhance data control, ensure seamless access to critical information."
}

const designData = {
  head:"Tailored Solutions for Educational Institutions",
  img:"/assets/images/educational-industry-design.webp",
  desc:[
    "We specialize in delivering structured and scalable document management systems designed to meet the evolving needs of educational environments. Our solutions ensure that every document is organized, accessible, aligned with academic and compliance requirements.",
    "With a deep understanding of institutional workflows, we help organizations reduce manual effort, improve turnaround times, maintain better control over critical data.",
  ],
  list:[
    "Secure management of student records and academic documentation",
    "Controlled access for enhanced data security and governance",
    "Quick and accurate document retrieval",
    "Compliance-focused academic records management systems",
    "Workflow automation to simplify administrative operations",
    "Scalable solutions designed to support institutional growth",
  ]
}



const tabData = [
  {
    icon: "/assets/images/home-tab-icon-1.webp",
    title: "Physical Records & Archive Management",
    heading:"Secure, Structured, Scalable Physical Record Storage",
    desc:"Managing physical documents doesn’t have to mean cluttered offices or lost files. At Dox and Box, we offer end-to-end physical records management designed to keep your documents secure, accessible, fully compliant. Our state-of-the-art archival facilities are built with strict security protocols, environmental controls, fire safety systems.",
    slug:"/physical-records-management-services",
    image:"/assets/images/home-tab-image-1.webp"
  },
  {
    icon: "/assets/images/home-tab-icon-2.webp",
    title: "Scanning & Digitization Services",
    heading:"Transform Paper Documents into Searchable Digital Assets",
    desc:"Move beyond manual paperwork with high-precision scanning and digitization services. We convert your physical records into structured, searchable, easily accessible digital formats. Using advanced scanning technology and intelligent indexing, we ensure every document is accurately captured and categorized.",
    slug:"/digitization-services",
    image:"/assets/images/home-tab-image-2.webp"
  },
  {
    icon: "/assets/images/home-tab-icon-3.webp",
    title: "Intelligent Document Processing & AI-driven Extraction",
    heading:"Unlock Data from Documents with AI-Powered Intelligence",
    desc:"Turn unstructured documents into actionable data with our AI-driven document processing solutions. We leverage advanced technologies like machine learning, OCR, natural language processing to extract, classify, validate information automatically. From invoices and contracts to forms and reports, our system reduces manual effort, minimizes errors, accelerates workflows. ",
    slug:"/ai-document-data-extraction",
    image:"/assets/images/home-tab-image-3.webp"
  },
  {
    icon: "/assets/images/home-tab-icon-4.webp",
    title: "Data Governance & Compliance Platform (SaaS)",
    heading:"Ensure Compliance, Control, Visibility Across Your Data",
    desc:"In today’s regulatory landscape, managing data securely and compliantly is critical. Our SaaS-based data governance platform provides centralized control over your documents, ensuring they are stored, accessed, managed in line with industry regulations. With role-based access, audit trails, retention policy automation, businesses gain complete visibility and control over their data.",
    slug:"/data-privacy-governance-compliance-platform",
    image:"/assets/images/home-tab-image-4.webp"
  },
]


const investData = {
  head:"Why Educational Institutions Need Smart Document Management?",
  boxes:[
    {
      img:'/assets/images/educational-industry-invest-1.webp',
      icon:"/assets/images/educational-industry-invest-icon-1.webp",
      title:"Record Organization",
      desc:"Structures academic data for consistent and efficient management.",
    },
    {
      img:'/assets/images/educational-industry-invest-2.webp',
      icon:"/assets/images/healthcare-industry-invest-icon-2.webp",
      title:"Policy Compliance Control",
      desc:"Ensures records align with institutional and regulatory requirements.",
    },
    {
      img:'/assets/images/educational-industry-invest-3.webp',
      icon:"/assets/images/educational-industry-invest-icon-3.webp",
      title:"Enhanced Process Speed",
      desc:"Improves turnaround time for academic and admin workflows.",
    },
    {
      img:'/assets/images/educational-industry-invest-4.webp',
      icon:"/assets/images/educational-industry-invest-icon-4.webp",
      title:"Data Protection Assurance",
      desc:"Secures confidential student and institutional information.",
    },
    {
      img:'/assets/images/educational-industry-invest-5.webp',
      icon:"/assets/images/educational-industry-invest-icon-5.webp",
      title:"Lower Administrative Burden",
      desc:"Reduces manual workload and operational inefficiencies.",
    },
    {
      img:'/assets/images/educational-industry-invest-6.webp',
      icon:"/assets/images/educational-industry-invest-icon-6.webp",
      title:"Seamless Information Access",
      desc:"Enables quick retrieval of records across departments.",
    },
  ]
}

const serveData = {
  head:"Other Industries We Serve",
  boxes:[
    {
      img:"/assets/images/educational-industry-serve-1.webp",
      title:"Healthcare Services",
      desc:"Healthcare requires secure and efficient management of patient records and critical data, ensuring organized and compliant document systems.",
      btnText:"Know More",
      slug:"/healthcare"
    },
    {
      img:"/assets/images/financial-industry-serve-2.webp",
      title:"Media & Entertainment",
      desc:"Media & Entertainment requires management of digital content and documents, ensuring organized, secure, accessible assets.",
      btnText:"Know More",
      slug:"/media-entertainment-records-management"
    },
  ]
}

export default function Educational() {
  return (
    <>
      <DynamicBreadcrumb breadcrumbData={breadcrumbData} />
      <SustainabilityBanner data={bannerData} />
      <IndustrySector data={sectorData} />
      <IndustryDesign data = {designData}/>
      <HomeTab tabData={tabData}/>
      <HomeResource/>
      <IndustryInvest data = {investData}/>
      <IndustryServe data={serveData}/>
    </>
  )
}
